import { render } from "./StartProjectModal.vue?vue&type=template&id=79143b96&scoped=true"
import script from "./StartProjectModal.vue?vue&type=script&lang=js"
export * from "./StartProjectModal.vue?vue&type=script&lang=js"

import "./StartProjectModal.vue?vue&type=style&index=0&id=79143b96&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79143b96"]])

export default __exports__